// src/components/BottomNav.js
import { C, FONTS } from '../styles/theme';
import { NavIcon } from './Icon';

const TABS = [
  { id: 'accueil', label: 'Accueil', path: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
  { id: 'jeux',    label: 'Jeux',    path: 'M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5' },
  { id: 'idees',   label: 'Idées',   path: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z' },
  { id: 'shop',    label: 'Shop',    path: 'M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z' },
  { id: 'plus',    label: 'Plus',    path: 'M4 6h16M4 12h16M4 18h16' },
];

export function BottomNav({ active, onNav }) {
  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: C.bg, borderTop: `1px solid ${C.sand}`,
      display: 'flex', justifyContent: 'space-around',
      padding: '10px 0 18px', zIndex: 100,
      maxWidth: 430, margin: '0 auto',
    }}>
      {TABS.map(t => {
        const on = active === t.id;
        return (
          <button key={t.id} onClick={() => onNav(t.id)} style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
            background: 'none', border: 'none', cursor: 'pointer',
            opacity: on ? 1 : 0.38,
            transform: on ? 'scale(1.08)' : 'scale(1)',
            transition: 'all 0.2s ease',
          }}>
            <NavIcon path={t.path} active={on}/>
            <span style={{ fontSize: 10, fontFamily: FONTS.body, fontWeight: on ? '600' : '400', color: on ? C.roseDark : C.textMid }}>
              {t.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
